import { Typography } from '@mui/material'

import { ModalWrapProps } from 'common/interfaces'
import { deleteBtnStyle } from 'common/styles'
import ModalActionCancelButtons from 'components/Modals/components/ModalActionCancelButtons'
import ModalWrap from 'components/ModalWrap'
import { useSessionState } from 'context/Session'
import { useStartOver } from 'utils/flow'

type RestartFlowModalProps = Pick<ModalWrapProps, 'open' | 'onClose'> & {
  labeledMode?: boolean
}

export default function RestartFlowModal({
  open,
  onClose,
  labeledMode = false,
}: RestartFlowModalProps): JSX.Element {
  const startOver = useStartOver(true)

  const { isSubmitted } = useSessionState()

  const restartFlowHandler = (): void => {
    startOver()
    onClose()
  }

  const title = labeledMode ? 'Start a new claim?' : 'Restart this flow?'
  const actionText = labeledMode ? 'Start new claim' : 'Restart flow'
  const bodyText = labeledMode
    ? 'This will delete all of your entered claim data. This action cannot be undone.'
    : 'This will delete all of your entered data. This action cannot be undone.'

  return (
    <ModalWrap
      title={title}
      open={open}
      onClose={onClose}
      actions={
        <ModalActionCancelButtons
          actionHandler={restartFlowHandler}
          onClose={onClose}
          textAction={actionText}
          textCancel="Cancel"
          actionStyle={deleteBtnStyle}
        />
      }
    >
      {!isSubmitted && <Typography>{bodyText}</Typography>}
    </ModalWrap>
  )
}
